import React from 'react';
import { X } from 'lucide-react';
import CardImage from './CardImage';
import './DetailSidePanel.css';

/**
 * Baustein — Detail-Side-Panel.
 * Auswahl-getriebenes Detail-Panel neben einer Liste/Tabelle: Desktop als
 * sticky Sidebar (320px-Spalte im PageSplit); unter 900px wird es zum
 * fixierten Bottom-Sheet über dem Inhalt (Sheet-CSS kommt mit der
 * Wantlist-Migration M5). Zeigt Kontextinformation und Aktionen — niemals
 * Daten, die auf der Karte selbst stehen.
 *
 * NICHT zu verwechseln mit dem künftigen „Card-Detail"-Modal (kontextabhängiges
 * Modal, von jeder dargestellten Karte aus öffenbar, mit Scryfall-Livedaten,
 * Links und seitenabhängigen Aktionen) — das ist ein eigenes Zukunfts-Feature,
 * Vision dokumentiert in docs/notes/TODO.md.
 *
 * Das Kartenbild rendert über `ui/CardImage` — Flip-Button doppelseitiger
 * Karten und onError-Platzhalter inklusive.
 *
 * Props:
 *   cardName    — Karten-Name (für Header)
 *   image       — URL zum Kartenbild (Vorderseite)
 *   imageBack   — optional: URL der Rückseite (doppelseitige Karte → Flip-Button)
 *   imageOrientation — optional: `imageOrientation` aus dem Umschlag; Querformat-Karten
 *                 liegen dann quer (Modus `landscape="always"` von ui/CardImage)
 *   imageAction — optional: kleine Aktion direkt unter dem Bild (z.B. „Print wechseln")
 *   onDismiss   — optional fn; rendert einen Schließen-X (nur mobil sichtbar,
 *                 wo das Panel zum Bottom-Sheet wird). Aufgabe des Callers:
 *                 Auswahl aufheben.
 *   children    — Detail-Inhalt (Kontext, Aktionen)
 */
export default function DetailSidePanel({
  cardName,
  image,
  imageBack,
  imageOrientation,
  imageAction,
  onDismiss,
  children,
}) {
  return (
    <aside className="detail-side-panel">
      {onDismiss && (
        <button
          type="button"
          className="detail-side-panel__dismiss"
          onClick={onDismiss}
          aria-label="Details schließen"
        >
          <X size={16} aria-hidden />
        </button>
      )}
      {image && (
        <div className="detail-side-panel__image-block">
          <div className="detail-side-panel__image-wrap">
            <CardImage src={image} backSrc={imageBack} alt={cardName} landscape="always" orientation={imageOrientation} />
          </div>
          {imageAction && (
            <div className="detail-side-panel__image-action">{imageAction}</div>
          )}
        </div>
      )}
      <div className="detail-side-panel__body">
        <h3 className="detail-side-panel__name">{cardName}</h3>
        {children}
      </div>
    </aside>
  );
}
